import styled from 'styled-components';

export const TopPanelWrapper = styled.div`
  margin-bottom: 5px;
  position:relative;
  background-color: #ffffff;
  width:100%;
  height: 100px;
`;

export const Title = styled.h2`
  font-size: 1.5em;
  text-align: left;
  margin-left: 0.4em;
  margin-top: 1em;
`;

export const ConfigWrapper = styled.div`
  display:flex;
  flex-direction: column;
  margin: 8px 8px 8px 8px;
  position: relative;
  height: calc(100% - 20px);
  align-items: center;
  justify-content: center;
`;

export const ContentWrapper = styled.div`
  height: 100%;
  width:100%;
  display: flex;
  flex-direction: column;
`;
